import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IDroneAreas } from 'src/models/drone-areas.model';
 import style from './drone-areas-list.module.scss';
import DroneAreasAdd from '../drone-areas-add/drone-areas-add-component';
import DroneAreasEdit from '../drone-areas-edit/drone-areas-edit.component';
import DroneAreasDelete from '../drone-areas-delete/drone-areas-delete.component';

type IProp = {
  data: IDroneAreas[];
  loading: boolean;
};

const DroneAreasView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IDroneAreas>[] = [
    {
      title: Lang.LBL_DRONE_AREAS_CITY_LOCATION,
      index: 'SensitiveCityLocation',
      width: '85%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <DroneAreasDelete data={value} />
          <DroneAreasEdit data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as IDroneAreas, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.LBL_SENSITIVE_CITIES_COMMUNITIES} />
        <DroneAreasAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default DroneAreasView;
